import React from 'react'
import './index.css'
import { Col, Container, Row } from 'react-bootstrap'

const bottomFooter = () => {
  return (
    <div className='bottom-footer align-items-center justify-content-center'>
    <Container>
        <Row>
            <Col >
                <div className="copyright text-center ">
                    <p>Copyright © 2025 <span className='brand'>PT Humdi Berkah Utama.</span> All rights reserved.</p>
                </div>
            </Col>
        </Row>
    </Container>
    </div>
  )
}

export default bottomFooter